module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.f44235f9.otf";